/*eslint react-hooks/exhaustive-deps: "off"*/
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { Alert, Button, Form, Radio, Spin, Tooltip } from "antd";
import MapPropsContext from "../MapPropsContext";
import { getPointByUid } from "../../../api";
import useInputs from "../../../utils/hooks/useInputs";
import "./WidgetSearchByUid.scss";
import {
  StyledButton,
  StyledDarkerButton,
} from "../../../styled-components/Button";
import {
  TI_ADDRESS_SEARCH_BUTTON,
  TI_SEARCH_PERMIT_NUMBER_TAB_BUTTON,
} from "../../../Constants";

const WidgetSearchByUid = ({ fetchUrl }) => {
  const [uidValue, setUidValue] = useState();
  const [message, setMessage] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const { setMapCenter, setClickedPointIconObjects } =
    useContext(MapPropsContext);

  const [inputsState, onChange] = useInputs({
    search_uid_type: "search-uid-type-1",
  });

  const moveToStation = useCallback(() => {
    // 초기화
    setClickedPointIconObjects([]);
    setMessage(null);
    setIsLoading(true);

    if (fetchUrl && uidValue.length > 0) {
      setMessage(null);
      setIsLoading(true);

      const params = {
        relUrl: fetchUrl,
        jungon:
          inputsState["search_uid_type"] === "search-uid-type-2" ? "Y" : "N",
        uidValue: uidValue.match(/\d+/g).join(""),
      };

      getPointByUid(params)
        .then(({ data }) => {
          if (data) {
            const stationList = data.data;

            if (stationList.length === 0) {
              setMessage("검색결과가 없습니다.");
            } else {
              const row = stationList[0];
              const { rds_pms_no, lat, lon, uid } = row;
              setMapCenter({ latitude: lat, longitude: lon, zoom: 16 });
              setTimeout(() => {
                setClickedPointIconObjects([
                  {
                    uid: rds_pms_no || uid,
                    latitude: lat,
                    longitude: lon,
                    position: [lon, lat],
                    jungon:
                      inputsState["search_uid_type"] === "search-uid-type-2"
                        ? "Y"
                        : "N",
                    sendGps: "Y",
                    ...row,
                  },
                ]);
              }, 400);
            }
          } else {
            setMessage("검색결과가 없습니다.");
          }
        })
        .catch((e) => {
          setMessage(`Error) ${e}`);
          console.error(e);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [fetchUrl, uidValue, inputsState]);

  const [tabState, setTabState] = useState(0);

  return (
    <div>
      <div style={{ margin: "5px 0px", display: "flex" }}>
        <StyledButton
          tabIndex={TI_SEARCH_PERMIT_NUMBER_TAB_BUTTON + 1}
          isActive={inputsState["search_uid_type"] === "search-uid-type-1"}
          onClick={() =>
            onChange({
              target: {
                name: "search_uid_type",
                value: "search-uid-type-1",
              },
            })
          }
          style={{ borderRadius: "4px 0px 0px 4px", flex: 1 }}
        >
          정기 (변경,허가)
        </StyledButton>
        <StyledButton
          tabIndex={TI_SEARCH_PERMIT_NUMBER_TAB_BUTTON + 2}
          isActive={inputsState["search_uid_type"] === "search-uid-type-2"}
          onClick={() =>
            onChange({
              target: {
                name: "search_uid_type",
                value: "search-uid-type-2",
              },
            })
          }
          style={{ borderRadius: "0px 4px 4px 0px", flex: 1 }}
        >
          준공 (심의중)
        </StyledButton>
      </div>
      {/* <Radio.Group
        name="search_uid_type"
        buttonStyle="solid"
        size="small"
        onChange={(e) => {
          console.log(e);
          onChange(e);
        }}
        value={inputsState["search_uid_type"]}
        style={{ display: "flex", marginBottom: 2 }}
      >
        <Radio.Button value="search-uid-type-1" style={BUTTON_STYLE}>
          정기 (변경,허가)
        </Radio.Button>
        <Radio.Button value="search-uid-type-2" style={BUTTON_STYLE}>
          준공 (심의중)
        </Radio.Button>
      </Radio.Group> */}

      <InputBlock disabled={isLoading} setUidValue={setUidValue} />

      {!fetchUrl && (
        <Alert message={"fetchUrl을 지정해주세요."} type={"error"} />
      )}
      {fetchUrl && (
        <StyledDarkerButton
          tabIndex={TI_SEARCH_PERMIT_NUMBER_TAB_BUTTON + 7}
          isActive={
            /^\d{2}-?\d{4}-?\d{2}-?\d{7}$/g.test(uidValue) && !isLoading
          }
          onClick={moveToStation}
          style={{ width: "100%", margin: "5px 0px" }}
        >
          {isLoading && <Spin />}
          {!isLoading && "검색하기"}
        </StyledDarkerButton>
      )}

      {message && <Alert message={message} />}
    </div>
  );
};

function InputBlock({ disabled, setUidValue }) {
  const ref2 = useRef();
  const ref3 = useRef();
  const ref4 = useRef();

  const [inputsState, onChange] = useInputs({
    field1: "",
    field2: "",
    field3: "",
    field4: "",
  });
  const { field1, field2, field3, field4 } = inputsState;

  useEffect(() => {
    const uid = `${field1}-${field2}-${field3}-${field4}`;
    setUidValue(uid);
  }, [field1, field2, field3, field4, setUidValue]);

  useEffect(() => {
    if (field1.length === 2) ref2.current.focus();
  }, [field1, ref2]);

  useEffect(() => {
    if (field2.length === 4) ref3.current.focus();
  }, [field2, ref3]);

  useEffect(() => {
    if (field3.length === 2) ref4.current.focus();
  }, [field3, ref4]);

  const onPaste = (e) => {
    const text = (e.clipboardData || window.clipboardData)
      .getData("text")
      .replace(/[^\d]+/g, "");
    onChange({ target: { name: "field1", value: text.slice(0, 2) } });
    onChange({ target: { name: "field2", value: text.slice(2, 6) } });
    onChange({ target: { name: "field3", value: text.slice(6, 8) } });
    onChange({ target: { name: "field4", value: text.slice(8, 15) } });
  };

  return (
    <span className={"ant-input-affix-wrapper"}>
      <Tooltip title={"허가번호를 입력해주세요."} placement={"bottom"}>
        <div className={["uid-field", "ant-input"].join(" ")}>
          <input
            tabIndex={TI_SEARCH_PERMIT_NUMBER_TAB_BUTTON + 3}
            type="text"
            name="field1"
            maxLength={2}
            size={2}
            disabled={disabled}
            value={field1}
            onChange={onChange}
            onPaste={onPaste}
            style={{ border: 0, width: "2em" }}
          />
          {"-"}
          <input
            tabIndex={TI_SEARCH_PERMIT_NUMBER_TAB_BUTTON + 4}
            type="text"
            name="field2"
            ref={ref2}
            maxLength={4}
            size={4}
            disabled={disabled}
            value={field2}
            onChange={onChange}
            onPaste={onPaste}
            style={{ border: 0, width: "4em" }}
          />
          {"-"}
          <input
            tabIndex={TI_SEARCH_PERMIT_NUMBER_TAB_BUTTON + 5}
            type="text"
            name="field3"
            ref={ref3}
            maxLength={2}
            size={2}
            disabled={disabled}
            value={field3}
            onChange={onChange}
            onPaste={onPaste}
            style={{ border: 0, width: "2em" }}
          />
          {"-"}
          <input
            tabIndex={TI_SEARCH_PERMIT_NUMBER_TAB_BUTTON + 6}
            type="text"
            name="field4"
            ref={ref4}
            maxLength={7}
            size={7}
            disabled={disabled}
            value={field4}
            onChange={onChange}
            onPaste={onPaste}
            style={{ border: 0, width: "7em" }}
          />
        </div>
      </Tooltip>
    </span>
  );
}

const BUTTON_STYLE = {
  flex: 1,
  textAlign: "center",
};

export default WidgetSearchByUid;
